// extracted by mini-css-extract-plugin
module.exports = {"group":"Swatches_group__dJXfi","radioButton":"Swatches_radioButton__aWCdS"};